module.exports = __webpack_public_path__ + "img/rock-big-16.31ab5768.png";